import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { useDispatch } from "react-redux";
import TransactionFormField from "./TransactionFormField";
import TransactionList from "./TransactionList";
import CreateReceipt from "./CreateReceipt";
import { useLocation } from "react-router-dom";
import ChangeReceipt from "./ChangeReceipt";
import CreateCustomerTransaction from "./CreateCustomerTransaction";
import ChangeCustomerTransaction from "./ChangeCustomerTransaction";
import TransactionAppointmentPopup from "./TransactionAppointmentPopup";
import data from "../../assets/apiRoutes.json";
import TransactionDetail from "./TransactionDetail";
import { Reset_Change_Receipt_Items } from "../../redux/actions/receipt";
import { Reset_Items } from "../../redux/actions/receipt";
import * as PermissionsConstants from "../../const/constants";
import TransactionCrudButtons from "./TransactionCrudButtons";
import TransactionSerialNumberManifest from "./TransactionSerialNumberManifest";
import TransactionSchedulingPopUp from "./TransactionSchedulingPopUp";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getAppSettings, GetDateTimeStandardFormat } from "../../common/Utils";
import _ from "lodash";
import { Statuses } from "../../enum/Enum";

const TransactionSearchForm = (props) => {
  const location = useLocation();
  const [disable, setDisable] = useState(true);
  const [disableEditDelete, setDisableEditDelete] = useState(false);
  var accessToken = props.oidc.user.access_token;
  const [showIcon, setShowIcon] = React.useState(getAppSettings()?.FiltersCollapsed? false : true);
  const [stateSerialNumbPopUp, setStateSerialNumbPopUp] = useState(false);
  const [deleteTransactionnumber, setDeletTransactionnumber] = useState(null);
  const [transactionRowId, setTransactionRowId] = useState("");
  const [receipt, setReceipt] = useState({
    shipperBolNumber: "",
    salesOrderNo: "",
    transactionDate: "",
    reference: "",
    container: "",
    transactionNumber: "",
    transactionnumberfrom: "",
    transactionnumberto: "",
    equipmentinterchangereport: "",
    rShipperFrom: "",
    rShipperTo: "",
    shippernamefrom: "",
    shippernameto: "",
    rConsigneeFrom: "",
    rConsigneeTo: "",
    consigneenamefrom: "",
    consigneenameto: "",
    transactionType:
      props.permission === PermissionsConstants.TransactionReceipt
        ? "R"
        : props.permission === PermissionsConstants.TransactionAdjustment
          ? "A"
          : "S",
    comment: "",
    status: props?.status ? "Z" : "",
    actualreceivedshippeddatetimeto: "",
    actualreceivedshippeddatetimefrom: "",
    dbName:
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "",
    rCustomerFrom: "",
    rCustomerTo: "",
    customernamefrom: "",
    customernameto: "",
  });
  const [stateTransSchedulingPopUp, setStateTransSchedulingPopUp] =
    useState(false);
  const [stateTransAppointmentPopUp, setStatestateTransAppointmentPopUp] =
    useState(false);
  const [transactionType, setTransactionType] = useState({
    transactionType:
      props.permission === PermissionsConstants.TransactionReceipt
        ? "R"
        : props.permission === PermissionsConstants.TransactionAdjustment
          ? "A"
          : "S",
    dbName:
      props.ReceiptReducer.wmTransactionDatabase !== ""
        ? props.ReceiptReducer.wmTransactionDatabase
        : "",
  });
  const setSearchPanelStatus = (v) => {
    setShowIcon(v);
  };

  const handleClickOpenTransSchedulingDialogue = () => {
    if (transactionRowId) setStateTransSchedulingPopUp(true);
  };
  const handleCloseSchedulingPopUpCallback = (ChildData) => {
    setStateTransSchedulingPopUp(ChildData);
  };
  const handleClickOpenTransAppointmentDialogue = () => {
    if (transactionRowId) setStatestateTransAppointmentPopUp(true);
  };
  const handleCloseAppointmentPopUpCallback = (ChildData) => {
    setStatestateTransAppointmentPopUp(ChildData);
  };

  const handleClickOpenDialogue = () => {
    if (transactionRowId) setStateSerialNumbPopUp(true);
  };
  const [dataSource, setDataSource] = useState(null);
  const searchData = (data) => {
    setDataSource(data);
  }

  const resetSearchedData = () => {
    setReceipt({
      shipperBolNumber: "",
      salesOrderNo: "",
      transactionDate: "",
      reference: "",
      container: "",
      transactionNumber: "",
      transactionnumberfrom: "",
      transactionnumberto: "",
      equipmentinterchangereport: "",
      rShipperFrom: "",
      rShipperTo: "",
      shippernamefrom: "",
      shippernameto: "",
      rConsigneeFrom: "",
      rConsigneeTo: "",
      consigneenamefrom: "",
      consigneenameto: "",
      transactionType:
        props.permission === PermissionsConstants.TransactionReceipt
          ? "R"
          : props.permission === PermissionsConstants.TransactionAdjustment
            ? "A"
            : "S",
      comment: "",
      status: props?.status ? "Z" : "",
      actualreceivedshippeddatetimeto: "",
      actualreceivedshippeddatetimefrom: "",
      dbName:
        props.ReceiptReducer.wmTransactionDatabase !== ""
          ? props.ReceiptReducer.wmTransactionDatabase
          : "",
      rCustomerFrom: "",
      rCustomerTo: "",
      customernamefrom: "",
      customernameto: "",
    });
  };
  const handleCallback = (childData) => {

    setTransactionRowId(childData.rowid);
    setDeletTransactionnumber(childData.transactionnumber);
    var disableEditDelete = childData.isAssociatedCustomerTrans;
    if (!disableEditDelete && (transactionType.transactionType == "R" || transactionType.transactionType == "S")) {
      var stage = childData.stageFlag;
      var editDelFromStage = "R";
      if (transactionType.transactionType == "R" && props.oidc.user.profile.hasOwnProperty("RECEDITDELFROMSTAGE")) {
        editDelFromStage = props.oidc.user.profile.RECEDITDELFROMSTAGE;
      }
      else if (transactionType.transactionType == "S" && props.oidc.user.profile.hasOwnProperty("SHIPEDITDELFROMSTAGE")) {
        editDelFromStage = props.oidc.user.profile.SHIPEDITDELFROMSTAGE;
      }


      switch (stage) {
        case "P":
          if (editDelFromStage == 'P') {
            disableEditDelete = true;
          }
          break;
        case "F":
          if (editDelFromStage == 'P' || editDelFromStage == 'F') {
            disableEditDelete = true;
          }
          break;
        case "N":
          if (editDelFromStage == 'P' || editDelFromStage == 'F' || editDelFromStage == 'N') {
            disableEditDelete = true;
          }
          break;
        case "R":
          if (editDelFromStage == 'P' || editDelFromStage == 'F' || editDelFromStage == 'N' || editDelFromStage == 'R') {
            disableEditDelete = true;
          }
          break;
        case "C":
          disableEditDelete = true;
          break;
      }
    }

    setDisable(false);
    setDisableEditDelete(disableEditDelete);
  };
  const transactionCallbackOnUnCheck = () => {
    setDisable(true);
  };

  const handleClosePopUpCallback = (ChildData) => {
    setStateSerialNumbPopUp(ChildData);
  };

  
  return (
    <div>
      <Switch>
        <Route exact path="/wm/transaction">
          <TransactionFormField
            permission={props.permission}
            resetQueryForm={resetSearchedData}
            setSearchPanelStatus={setSearchPanelStatus}
            searchData={searchData}
            transactionType={
              props.permission === PermissionsConstants.TransactionReceipt
                ? "R"
                : props.permission === PermissionsConstants.TransactionAdjustment
                  ? "A"
                  : "S"}
            statusFlag={Statuses.Active}
          />
        </Route>
        <Route
          path={
            props.permission === PermissionsConstants.TransactionReceipt
              ? "/wm/transaction/view-receipt"
              : props.permission ===
                PermissionsConstants.TransactionAdjustment
                ? "/wm/transaction/view-receipt"
                : "/wm/transaction/view-shippment"
          }
        >
          <TransactionDetail
            isTransItmsOnly={true}
            resetQueryForm={resetSearchedData}
            transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
            setSearchPanelStatus={setSearchPanelStatus}
            SearchPanelAccordionStatus={showIcon}
          />
        </Route>
        <Route exact path="/wm/transaction/create-customer-transaction">
          {(() => {
            if (props.permission === PermissionsConstants.TransactionReceipt || 
                props.permission === PermissionsConstants.TransactionShipment) {
              return (
                <CreateCustomerTransaction
                  rolePermission={props.permission}
                  resetQueryForm={resetSearchedData}
                  transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
                />
              );
            } else {
              return null;
            }
          })()}
        </Route>
        <Route
          path={
            props.permission === PermissionsConstants.TransactionReceipt
              ? "/wm/transaction/create-receipt"
              : "/wm/transaction/create-shippment"
          }
        >
          <CreateReceipt
            rolePermission={props.permission}
            resetQueryForm={resetSearchedData}
            transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
          />
        </Route>
        <Route
          exact
          path={
            props.permission === PermissionsConstants.TransactionReceipt
              ? "/wm/transaction/change-receipt"
              : "/wm/transaction/change-shippment"
          }
        >
          {(() => {
            return (
              <ChangeReceipt
                rolePermission={props.permission}
                resetQueryForm={resetSearchedData}
                transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
              />
            );
          })()}
        </Route>
        <Route
          exact
          path="/wm/transaction/change-customer-transaction"
        >
          {(() => {
            if (props.permission === PermissionsConstants.TransactionReceipt ||
                props.permission === PermissionsConstants.TransactionShipment) {
              return (
                <ChangeCustomerTransaction
                  rolePermission={props.permission}
                  resetQueryForm={resetSearchedData}
                  transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
                />
              );
            } else {
              return null;
            }
          })()}
        </Route>{" "}
      </Switch>
      {location.pathname === "/wm/transaction/view-receipt" ? (
        ""
      ) : location.pathname === "/wm/transaction/view-shippment" ? (
        ""
      ) : location.pathname === "/wm/transaction/create-receipt" ? (
        /* <CreateTransactionItems
          tabsValue={props.permission}
          changeQuantityCallback={createDetailsData}
        /> */
        ""
      ) : location.pathname === "/wm/transaction/create-shippment" ? (
        /*  <CreateTransactionItems
           tabsValue={props.permission}
           changeQuantityCallback={createDetailsData}
         /> */
        ""
      ) : location.pathname === "/wm/transaction/change-shippment" ? (
        ""
      ) : location.pathname === "/wm/transaction/change-receipt" ? (
        ""
      ) : (
        <TransactionList
          disable={disable}
          disableEditDelete={disableEditDelete}
          deletedTransactionNumber={deleteTransactionnumber}
          rowid={transactionRowId}
          permission={props.permission}
          data={dataSource}
          tabsValue={props.permission}
          transactionCallback={handleCallback}
          transactionCallbackOnUnCheck={transactionCallbackOnUnCheck}
          SearchPanelAccordionStatus={showIcon}
          handleClickOpenDialogue={handleClickOpenDialogue}
          handleClickOpenTransAppointmentDialogue={handleClickOpenTransAppointmentDialogue}
          handleClickOpenTransSchedulingDialogue={handleClickOpenTransSchedulingDialogue}
        />
      )}
      {stateSerialNumbPopUp && (
        <TransactionSerialNumberManifest
          transRowid={transactionRowId}
          visibility={stateSerialNumbPopUp}
          parentCallback={handleClosePopUpCallback}
        ></TransactionSerialNumberManifest>
      )}
      {stateTransAppointmentPopUp && (
        <TransactionAppointmentPopup
          transRowid={transactionRowId}
          visibility={stateTransAppointmentPopUp}
          parentCallback={handleCloseAppointmentPopUpCallback}
        ></TransactionAppointmentPopup>
      )}
      {stateTransSchedulingPopUp && (
        <TransactionSchedulingPopUp
          transRowid={transactionRowId}
          visibility={stateTransSchedulingPopUp}
          parentCallback={handleCloseSchedulingPopUpCallback}
        ></TransactionSchedulingPopUp>
      )}
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(TransactionSearchForm);
